export const styleguide = {
  colors: {
    green: '#008A00',
    gray: { 100: '#666666', 200: '#999999', 300: '#DFDFDF' },
    blue: { 100: '#005CDE' },
  },
  breakpoints: {
    mobile: '0px', // Dispositivos móveis (smartphones)
    tablet: '480px', // Tablets e dispositivos intermediários
    desktop: '768px', // Notebooks e desktops comuns
    wide: '1024px', // Telas maiores (monitores maiores)
    ultraWide: '1440px', // Telas muito amplas (4K ou ultrawide)
  },
};
